export const API_EVENTS_LIST_PAGE_SIZE = 5;
export const API_REGISTRATIONS_LIST_PAGE_SIZE = 5;
export const API_PAYMENTS_LIST_PAGE_SIZE = 5;
export const API_EXPENSES_LIST_PAGE_SIZE = 5;
export const API_ORDERS_LIST_PAGE_SIZE = 5;
export const API_PROGRAM_COURSE_REGISTRATIONS_LIST_PAGE_SIZE = 10;
export const API_LEGAL_GROUP_LIST_PAGE_SIZE = 1;
export const API_DOCUMENTS_LIST_PAGE_SIZE = 16;
export const API_NEWSLETTER_LIST_PAGE_SIZE = 10;
export const API_CONSENT_ENTITY_LIST_PAGE_SIZE = 100;

export const API_ADMIN_EVENT_LIST_PAGE_SIZE = 5;
export const API_ADMIN_EVENT_REGISTRATION_PAGE_SIZE = 10;

export const WP_API_POSTS_LIST_PAGE_SIZE = 6;

export const PAYMENT_SWISH_NUMBER = "123 068 88 20";
export const PAYMENT_SWISH_OWNER = "FÖRENINGEN LES QUATRE BARRES";
export const PAYMENT_TRANSFER_PLUSGIRO = "97 09 16-3";
export const PAYMENT_TRANSFER_BIC = "NDEASESS";
export const PAYMENT_TRANSFER_IBAN = "SE84 9500 0099 6042 0970 9163";
export const PAYMENT_TRANSFER_OWNER = "FÖRENINGEN LES QUATRE BARRES";

export const LANGUAGE_TO_GOOGLE_LOCALE_COUNTRY = {
  en: "enGB",
  ca: "ca",
  sv: "se",
};

export const LANGUAGE_TO_APPLE_WALLET_FILE = {
  en: ["US_UK", "US-UK_Add_to_Apple_Wallet_RGB_101421"],
  ca: ["CAES", "CAES_Add_to_Apple_Wallet_RGB_101421"],
  sv: ["SE", "SE_Add_to_Apple_Wallet_RGB_102021"],
};
